export { WatchActiveQuestionOfDictationSubscription } from './watch-active-question-of-dictation';
